export const VECON_PDF_DOCUMENTS = [
    { fileName: 'VECON_PersonalInfo_EN.pdf', en: 'Adult Change of Name Application', fr: 'Demande de changement de nom pour adulte', order: 1 },
    { fileName: 'VECON_PersonalInfo_FR.pdf', en: 'Adult Change of Name Application', fr: 'Demande de changement de nom pour adulte', order: 1 },
    { fileName: 'VECON_SingleName_EN.pdf', en: 'Request for a Name Change to a Single Name', fr: 'Demande de changement de nom pour un nom unique', order: 2 },
    { fileName: 'VECON_SingleName_FR.pdf', en: 'Request for a Name Change to a Single Name', fr: 'Demande de changement de nom pour un nom unique', order: 2 },
    { fileName: 'VECON_ConsentForm_EN.pdf', en: 'Consent Form 1', fr: 'Formulaire de consentement 1', order: 3 },
    { fileName: 'VECON_ConsentForm_FR.pdf', en: 'Consent Form 1', fr: 'Formulaire de consentement 1', order: 3 },
    { fileName: 'VECON_ConsentForm2_EN.pdf', en: 'Consent Form 2', fr: 'Formulaire de consentement 2', order: 4 },
    { fileName: 'VECON_ConsentForm2_FR.pdf', en: 'Consent Form 2', fr: 'Formulaire de consentement 2', order: 4 },
    { fileName: 'VECON_ConsentForm3_EN.pdf', en: 'Consent Form 3', fr: 'Formulaire de consentement 3', order: 5 },
    { fileName: 'VECON_ConsentForm3_FR.pdf', en: 'Consent Form 3', fr: 'Formulaire de consentement 3', order: 5 },
    { fileName: 'VECON_ConsentForm4_EN.pdf', en: 'Consent Form 4', fr: 'Formulaire de consentement 4', order: 6 },
    { fileName: 'VECON_ConsentForm4_FR.pdf', en: 'Consent Form 4', fr: 'Formulaire de consentement 4', order: 6 },
    { fileName: 'VECON_ConsentForm5_EN.pdf', en: 'Consent Form 5', fr: 'Formulaire de consentement 5', order: 7 },
    { fileName: 'VECON_ConsentForm5_FR.pdf', en: 'Consent Form 5', fr: 'Formulaire de consentement 5', order: 7 },
    { fileName: 'VECON_NoticeForm_EN.pdf', en: 'Notice Form 1', fr: "Formulaire d'avis 1", order: 8 },
    { fileName: 'VECON_NoticeForm_FR.pdf', en: 'Notice Form 1', fr: "Formulaire d'avis 1", order: 8 },
    { fileName: 'VECON_GuarantorForm_EN.pdf', en: "Guarantor's Statement Form", fr: 'Formulaire de déclaration du garant', order: 9 },
    { fileName: 'VECON_GuarantorForm_FR.pdf', en: "Guarantor's Statement Form", fr: 'Formulaire de déclaration du garant', order: 9 },
    { fileName: 'VECON_StatutoryForm_EN.pdf', en: 'Statutory Declaration Form', fr: 'Formulaire de déclaration solennelle', order: 10 },
    { fileName: 'VECON_StatutoryForm_FR.pdf', en: 'Statutory Declaration Form', fr: 'Formulaire de déclaration solennelle', order: 10 },
    { fileName: 'VECON_PaymentForm_EN.pdf', en: 'Payment Form', fr: 'Formulaire de paiement', order: 11 },
    { fileName: 'VECON_PaymentForm_FR.pdf', en: 'Payment Form', fr: 'Formulaire de paiement', order: 11 },
    { fileName: 'VECON_Checklist_EN.pdf', en: 'Change of name (adult) application checklist', fr: 'Liste de contrôle pour les demandes de changement de nom (adulte)', order: 12 },
    { fileName: 'VECON_Checklist_FR.pdf', en: 'Change of name (adult) application checklist', fr: 'Liste de contrôle pour les demandes de changement de nom (adulte)', order: 12 },
];

export const VECON_PDF_FILES = VECON_PDF_DOCUMENTS.map(({ fileName }) => ({ fileName }));

export const VECON_CONTENT = {
    en: {
        backToHome: "Back to home",
        backToOntario: "Back to Ontario.ca",

        pageTitle: "order-confirmation",
        tabTitle: "Your application has been submitted",

        successAlertTitle: "You've completed the online name change application - there are a few more steps you need to complete!",

        warningAlertTitle: "IMPORTANT: Do not close the page until you've reviewed the instructions and downloaded your documents. For privacy and security, copies cannot be emailed.",

        mainTitle: "Please download your documents",
        orderIdLabel: "Order ID: ",
        dateLabel: "Date: ",

        instructionTextCxp: "After reviewing the information and downloading your documents, you can close this page. Use the checklist to help you complete the next steps. You will be able to access your documents in your account inbox. Your documents will be stored in your account for 90 days.",
        instructionTextGuest: "After reviewing the information and downloading your documents, you can close this page. Use the checklist to help you complete the next steps.",

        downloadAllDocuments: "Download all documents",
        downloadChecklist: "Download next step checklist",

        whatToDoNext: "What to do next:",
        whatToDoNextIntro: "You've completed the online part of your name change application. Just a few offline steps remain. The personalized checklist below will guide you through them in more detail.",

        step1Title: "1- Print your documents:",
        step1Content: "Based on the information you provided, we've prepared the documents below for you to download and print. Please review each form carefully to ensure all details are correct. If anything is missing—such as dates or signatures—please have the appropriate person complete those sections.",
        step1Instruction: "Download and print the below forms we've prefilled based on your application.",

        step2Title: "2- Get required signatures:",
        step2Content: "Depending on your situation, some forms may require signatures from others, such as a spouse or partner, legal guardian, or cultural representative. A guarantor's signature is always required. If you identify as transgender or non-binary, or are First Nations, Inuit, or Métis, you may choose to opt out of having your name change published in the Ontario Gazette.",

        step3Title: "3- Gather supporting documents:",
        step3Content: "Collect the IDs and documents needed for your application. Depending on your circumstances, this may include birth certificates, immigration records, police record checks, proof of previous name changes, court orders or separation agreements, proof of marriage, and translations if any documents are not in English or French.",

        step4Title: "4- Visit a commissioner:",
        step4Content: "Bring your complete package to a commissioner for taking affidavits to sign the Statutory Declaration form.",

        step5Title: "5- Submit payment:",
        step5Content: "Complete the Payment form to authorize your payment.",

        step6Title: "6- Send your application:",
        step6Content: "Mail or drop off your full application package. If everything is in order, you'll receive your Change of Name Certificate by mail—and a new birth certificate if you were born in Ontario.",

        feedbackQuestion: "How was your experience today?",
        feedbackLink: "Share your feedback.",

        exploreServicesTitle: "Explore available services",
    },

    fr: {
        backToHome: "Retour à l'accueil",
        backToOntario: "Retourner à Ontario.ca",

        pageTitle: "confirmation-de-commande",
        tabTitle: "Votre demande a été soumise",

        successAlertTitle: "Vous avez rempli la demande de changement de nom en ligne. Il y a quelques autres étapes à suivre.",

        warningAlertTitle: "IMPORTANT: Ne fermez pas la page avant d'avoir passé en revue les instructions et téléchargé vos documents. Pour des raisons de confidentialité et de sécurité, les copies ne peuvent pas être envoyées par courriel.",

        mainTitle: "Veuillez télécharger vos documents",
        orderIdLabel: "Numéro de commande: ",
        dateLabel: "Date: ",

        instructionTextCxp: "Après avoir examiné les renseignements et téléchargé vos documents, vous pouvez fermer cette page. Utilisez la liste de contrôle pour vous aider à suivre les prochaines étapes. Vous pourrez accéder à vos documents dans la boîte de réception de votre compte. Vos documents seront conservés dans votre compte pendant 90 jours.",
        instructionTextGuest: "Après avoir examiné les renseignements et téléchargé vos documents, vous pouvez fermer cette page. Utilisez la liste de contrôle pour vous aider à suivre les prochaines étapes.",

        downloadAllDocuments: "Téléchargez tous les documents",
        downloadChecklist: "Téléchargez la liste de contrôle de l'étape suivante",

        whatToDoNext: "Prochaines étapes:",
        whatToDoNextIntro: "Vous avez rempli la partie en ligne de votre demande de changement de nom. Il ne reste que quelques étapes hors ligne. La liste de contrôle personnalisée ci-dessous vous aidera à les remplir plus en détail.",

        step1Title: "1- Imprimer vos documents:",
        step1Content: "En fonction des renseignements que vous avez fournis, nous avons préparé les documents ci-dessous pour que vous puissiez les télécharger et les imprimer. Veuillez examiner chaque formulaire attentivement pour vous assurer que tous les renseignements sont exacts. S'il manque quelque chose, comme des dates ou des signatures, veuillez demander à la personne appropriée de remplir ces sections.",
        step1Instruction: "Téléchargez et imprimez les formulaires ci-dessous que nous avons préremplis en fonction de votre demande.",

        step2Title: "2- Obtenir les signatures requises:",
        step2Content: "Selon votre situation, certains formulaires peuvent exiger la signature d'autres personnes, comme un conjoint ou un partenaire, un tuteur légal ou un représentant culturel. La signature du répondant est toujours requise. Si vous vous identifiez comme transgenre ou non binaire, ou si vous êtes membre des Premières Nations, Inuit ou Métis, vous pouvez choisir de ne pas faire publier votre changement de nom dans la Gazette de l'Ontario.",

        step3Title: "3- Rassembler les pièces justificatives:",
        step3Content: "Recueillez les pièces d'identité et les documents nécessaires pour votre demande. Selon votre situation, cela peut comprendre les certificats de naissance, les dossiers d'immigration, la vérification des dossiers de police, la preuve de changements de nom antérieurs, les ordonnances du tribunal ou les ententes de séparation, la preuve de mariage et les traductions si certains documents ne sont pas en français ou en anglais.",

        step4Title: "4- Visite à un commissaire:",
        step4Content: "Apportez votre trousse complète à un commissaire à l'assermentation pour signer le formulaire de déclaration solennelle.",

        step5Title: "5- Soumettre le paiement:",
        step5Content: "Remplissez le formulaire de paiement pour autoriser votre paiement.",

        step6Title: "6- Envoyer votre demande:",
        step6Content: "Envoyez votre trousse de demande complète par la poste ou déposez-la en personne. Si tout est en ordre, vous recevrez votre certificat de changement de nom par la poste – et un nouveau certificat de naissance si vous êtes né en Ontario.",

        feedbackQuestion: "Comment s’est passée votre expérience aujourd’hui?",
        feedbackLink: "Faites-nous part de vos commentaires.",

        exploreServicesTitle: "Explorer les services disponibles",
    }
};

const VECON_PDF_DISPLAY_NAMES = Object.fromEntries(
    VECON_PDF_DOCUMENTS.map(({ fileName, en, fr, order }) => [fileName, { en, fr, order }])
);

export const getVeconContent = (isEng: boolean) => {
    return VECON_CONTENT[isEng ? 'en' : 'fr'];
};

export const getVeconDisplayName = (fileName: string, isEng: boolean): string => {
    const entry = VECON_PDF_DISPLAY_NAMES[fileName];
    if (entry) {
        return isEng ? entry.en : entry.fr;
    }
    return fileName;
};

export const getVeconPdfOrder = (fileName: string): number => {
    return VECON_PDF_DISPLAY_NAMES[fileName]?.order ?? Number.MAX_SAFE_INTEGER;
};
